<template>
  <div id="app">
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-row>
        <b-col md="4" class="my-1">
          <b-navbar-nav>
            <b-button @click="goBack" size="xxl" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-col>
        <b-col md="6" class="my-1">
          <h5>
            <b-badge :variant="'info'"
              ><b> {{ $route.name }} </b></b-badge
            >
          </h5>
        </b-col>
        <b-col md="2" class="my-1">
          <b-button
            @click="goRolloverCont()"
            size="sm"
            variant="success"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Rollover Container</b-button
          ></b-col
        >
      </b-row>
      <div class="mt-3">
        <b-row>
          <b-col md="8">
            <div class="events-section">
              <div class="eventTitle">
                <b-row>
                  <b-col md="9">
                    <span>Events</span>
                  </b-col>

                  <b-col md="0.5" class="filter"> Filter last </b-col>

                  <b-col md="2">
                    <model-list-select
                      :list="filterList"
                      id="filter"
                      v-model="Filter"
                      option-value="filterId"
                      option-text="filterText"
                    ></model-list-select>
                  </b-col>

                  <b-col class="filter"> day </b-col>
                </b-row>
              </div>
              <!-- {{events}} -->
              <transition-group name="event" tag="div" class="events-panel">
                <div v-for="(event, index) in events" :key="index" class="event-card">
                  <!-- v-for="event in events" :key="event.id" -->
                  <div @click="toggleAccordion(event, index, 'event')">
                    <i class="fa fa-ship"></i> {{ event.type }}<br />
                    <span style="color: #2f6796">{{ event.countLog }} containers </span>
                    (in {{ event.subscriptionsLog }} subscriptions)
                  </div>

                  <div v-show="event.isOpen">
                    <!-- <span style="color: #2f6796">{{ event.countLog }} containers </span>
                    (in {{ event.subscriptionsLog }} subscriptions) -->

                    <div class="box-body" v-if="event.bookingList.length > 0">
                      <table id="portLocationNew" class="table table-bordered">
                        <thead>
                          <tr>
                            <th>SN</th>

                            <th>Carrier</th>

                            <th>Carrier ref. #</th>

                            <th>Internal ref. # / Description</th>
                            <!-- <th>Days</th> -->
                            <th>Affected containers</th>
                            <th>Event Code</th>
                            <!-- <th>Module No</th> -->
                            <th>Job No</th>
                            <th>Job Date</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(item1, index) in event.bookingList" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td>{{ item1.shipment_carrier_scac }}</td>

                            <td>
                              <span
                                :style="
                                  item1.subscription_id
                                    ? 'color: blue;font-weight:bold'
                                    : ''
                                "
                                @click="
                                  item1.subscription_id ? goToSubscriptionPage(item1) : ''
                                "
                                >{{ item1.booking_number }}</span
                              >
                            </td>

                            <td>{{ item1.event_details_message }}</td>

                            <!-- <td>{{ item1.pod_timeofarrival_warning_days_diff }}</td> -->

                            <td>
                              <span
                                :style="
                                  item1.subscription_id
                                    ? 'color: blue;font-weight:bold'
                                    : ''
                                "
                                @click="
                                  item1.shipment_id ? getShipmentSubscription(item1) : ''
                                "
                                >{{ item1.total_cont }}</span
                              >
                            </td>

                            <td>{{ item1.event_code }}</td>

                            <!-- <td>{{ item1.fk_all_module_id }}</td> -->
                            <td>
                              <span
                                :style="
                                  item1.subscription_id
                                    ? 'color: blue;font-weight:bold'
                                    : ''
                                "
                                @click="item1.ffExportFclId ? goExportFCLPage(item1) : ''"
                                >{{ item1.JobNo }}</span
                              >
                            </td>
                            <td>{{ item1.JobDate }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </b-col>
          <b-col md="4">
            <div class="events-section">
              <h5>Incidents</h5>
              <transition-group name="notification" tag="div">
                <!-- v-for="notification in notifications"
                  :key="notification.id" -->
                <div
                  v-for="(notification, index) in notifications"
                  :key="index"
                  class="notification-card"
                >
                  <div
                    class="notification-card-title"
                    @click="toggleAccordion(notification, index, 'notification')"
                  >
                    <!-- {{notification}} -->
                    <b>{{ parseInt(index + 1) + "." }}{{ notification.title }}</b>
                    <i class="arrow" :class="notification.isOpen ? 'up' : 'down'"></i>
                  </div>
                  <!-- {{ notification.isOpen }} -->
                  <b-card class="mainCardBG" v-show="notification.isOpen">
                    <b-card-text>
                      <p>{{ notification.description }}</p>
                    </b-card-text>
                  </b-card>
                  <center>
                    <button
                      class="show-button mt-3"
                      v-if="notification.buttonPresent"
                      @click="getAffectedContainers(notification, index)"
                    >
                      Show affected containers
                    </button>
                  </center>
                  <!-- <button class="show-button">Show affected containers</button> -->
                </div>
              </transition-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import DateRangePicker from "vue2-daterange-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    // if (globalPermissionStatus("Dashboard_Access")) {

    if (
      globalPermissionStatus("Dashboard_Access") ||
      globalPermissionStatus("Sea Freight")
    ) {
      this.$store.dispatch("setCurrentRoute", this.$router.path);
      this.getAllIncidents();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},
  data() {
    return {
      docURL: URL_BASE_DOC,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      Filter: "",
      filterList: [
        {
          filterId: "1",
          filterText: "1",
        },
        {
          filterId: "2",
          filterText: "2",
        },
        {
          filterId: "3",
          filterText: "3",
        },
      ],

      events: [
        {
          type: "Container gate-out at POD",
          count: 8,
          event_code: 5,
          subscriptions: 6,
          isOpen: false,
        },
        {
          type: "Rollover warning (vessel change)",
          count: 42,
          event_code: 4,
          subscriptions: 13,
          isOpen: false,
        },
        {
          type: "Port changed (rerouting)",
          count: 1,
          event_code: 16,
          subscriptions: 1,
          isOpen: false,
        },
        {
          type: "ETD at POL postponed (> 2 days)",
          count: 6,
          event_code: 24,
          subscriptions: 24,
          isOpen: false,
        },
        {
          type: "ETA at POD postponed (> 2 days)",
          count: 53,
          event_code: 8,
          subscriptions: 17,
          isOpen: false,
        },
        {
          type: "Vessel approaching POD",
          count: 21,
          event_code: 3,
          subscriptions: 16,
          isOpen: false,
        },
      ],
      notifications: [
        {
          message: "Maersk has temporarily stopped the acceptance of any new bookings.",
          buttonPresent: true,
          isOpen: false,
        },
        {
          message: "Malaysia bans Zim ships from docking at its ports.",
          buttonPresent: true,
          isOpen: false,
        },
        {
          message: "Malaysia bans all Israeli and Israel-bound ships starting today.",
          buttonPresent: false,
          isOpen: false,
        },
        { message: "Vessels dwelling in the Red Sea.", buttonPresent: true },
        {
          message: "OOCL and Cosco stopped accepting Israeli cargo.",
          buttonPresent: true,
          isOpen: false,
        },
      ],
    };
  },
  methods: {
    goRolloverCont() {
      this.$router.push({
        path: "/ctt/rollover-event",
      });
    },
    goToSubscriptionPage(item) {
      if (item.subscription_id) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
        });
      }
    },
    getShipmentSubscription(item) {
      this.$router.push({
        path: "/tracking/ocean-insights/shipment/" + item.shipment_id,
      });
    },
    goExportFCLPage(item) {
      let FCLID = item.ffExportFclId;
      if (item.isConsolidation == 0 && item.isMiscJob == 0) {
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$router.push({
            path: "/freightForward/newffExportFcl",
          });
        } else {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$router.push({
            path: "/freightForward/ffExportFcl",
          });
        }
      } else if (item.isConsolidation == 1 && item.isMiscJob == 0) {
        let FCLCONID = item.ffExportFclId;
        this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      } else if (item.isMiscJob == 1 && item.isConsolidation == 0) {
        this.$sessionsStorage.set("editSalesExId", item.fk_all_module_id);
        this.$router.push({
          path: "/mainEnquiry/miscSalesExecutionAll",
        });
      }
    },
    getAffectedContainers(notification, index) {
      let myPath = "/tracking/ocean-insights/affectedCont/";
      // console.log("router=>",this.$route.path)
      // alert(this.$route.path)
      if (this.$route.path == "/tracking/ocean-insights") {
        myPath = "/tracking/ocean-insights/affectedCont/";
      } else {
        myPath = "/tracking/ff-ocean-insights/affectedCont/";
      }
      this.$router.push({
        path: myPath + notification.id,
      });
    },
    toggleAccordion(item, index, type) {
      if (type == "event") {
        this.events[index].isOpen = !item.isOpen;
      } else if (type == "notification") {
        this.notifications[index].isOpen = !item.isOpen;
      }
      this.$forceUpdate();
    },
    goBack() {
      window.history.go(-1);
    },
    getAllIncidents() {
      this.isLoading = true;
      let payload = {};
      this.notifications = [];
      payload = {
        itemCode: "getAllIncidents",
      };

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("getAllIncidents PS =>", data);
            if (data.getAllIncidents.length > 0) {
              this.notifications = data.getAllIncidents;
              this.events = data.events;
              this.notifications.map((item) => {
                item.isOpen = false;
                item.buttonPresent = false;
                if (
                  item.vessels.length > 0 ||
                  item.ports.length > 0 ||
                  item.carriers.length > 0
                ) {
                  item.buttonPresent = true;
                }
              });
              console.log("this.notifications=>", this.notifications);
              // window.location.href =
              //   `https://uploadsp.pridel.com/Pridel_Reports/` +
              //   data.excelName;
              this.isLoading = false;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on getAllIncidents Error: ", error);
        });
    },
  },

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    CustomLoader,
  },
};
</script>

<style>
.show-button {
  background-color: #f0b429; /* Blue background */
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  /* position: absolute; */
  right: 10px;
  bottom: 10px;
  border-radius: 5px;
}

.show-button:hover {
  background-color: #0056b3; /* Darker blue on hover */
}
/* Responsive layout */
@media (max-width: 768px) {
  .events-section,
  .notifications-section {
    margin-bottom: 20px;
  }
}

.eventTitle {
  margin-bottom: 2%;
  font-weight: bold;
  font-size: 16px;
}

.filter {
  font-size: 14px;
}

.events-section {
  background-color: #e4e7eb;
  padding: 2%;
  font-weight: bold;
  color: #7b8798;
}

.events-panel {
  background-color: white;
  padding: 1%;
}

/* Event and notification card styling */
.event-card {
  background-color: #e4e7eb;
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  font-size: 14px;
  border-radius: px;
}
.notification-card-title {
  background-color: #fff3c4;
  padding: 10px;
  min-height: 45px;
  border-radius: 3px;
  margin-bottom: 10px;
}

.notification-card {
  background-color: #fffbea;
  border: 2px solid #f0b429;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  font-size: 14px;
  border-radius: 5px;
}

/* Hover effect */
.event-card:hover,
.notification-card:hover {
  transform: translateY(-5px);
}

/* Animation */
.event-enter-active,
.event-leave-active,
.notification-enter-active,
.notification-leave-active {
  transition: all 0.5s;
}

.event-enter, .event-leave-to /* .event-leave-active in <2.1.8 */,
.notification-enter, .notification-leave-to /* .notification-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.accordion-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  padding: 10px;
  width: 100%;
  text-align: left;
}

.arrow {
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
</style>



// WEBPACK FOOTER //
// containerTrack.vue?414d921d